import React from 'react'

const SuspenseLoading = () => <small></small>

export default SuspenseLoading
